import React from "react";
import "animate.css";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import CheckIcon from "@material-ui/icons/Check";
import "../assets/style.css";
import "../assets/main.css";
import "../assets/Tailwind.css";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import image from "./img/FotoVIVERO.jpeg";
import image2 from "./img/FotoVIVERO.jpeg";
import image6 from "./img/FotoVIVERO.jpeg";
import image7 from "./img/FotoVIVERO.jpeg";
import image3 from "./img/FotoVIVERO.jpeg";
import image4 from "./img/FotoVIVERO.jpeg";
import image5 from "./img/FotoVIVERO.jpeg";
import image8 from "./img/FotoVIVERO.jpeg";
import image9 from "./img/FotoVIVERO.jpeg";
import image10 from "./img/FotoVIVERO.jpeg";
import image11 from "./img/FotoVIVERO.jpeg";
import image33 from "./img/FotoVIVERO.jpeg";
import image34 from "./img/FotoVIVERO.jpeg";
import image35 from "./img/FotoVIVERO.jpeg";
import image36 from "./img/FotoVIVERO.jpeg";
import image37 from "./img/FotoVIVERO.jpeg";
import image38 from "./img/FotoVIVERO.jpeg";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export const Services = () => {
  const classes = useStyles();
  return (
    <>

      <div
        /* className={classes.root} */ style={{
          marginTop: "30px",
          marginBottom: "20px",
        }}
      >
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography
              className={classes.heading}
              style={{ color: "#f4541c", fontWeight: 'bold' }}
            >
              {" "}
              <CheckIcon />
              División Producción
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>
                Este sector es el encargado de la producción propiamente dicha, de todas las plantas que comercializamos y trabaja con el objetivo de mantener y mejorar en forma continua el rendimiento y la calidad de las mismas, teniendo en cuenta las variaciones de la demanda del mercado en general y de nuestros clientes en particular.

               <br></br>
               <span style={{fontWeight: 'bold', marginTop: '10px', marginBottom: '10px'}}>NUESTRAS LÍNEAS DE PRODUCCIÓN SON:</span>
               <br></br>

                <ol style={{ textAlign: 'initial', marginTop: '10px', marginBottom: '10px', paddingLeft: '20px' }}>
                  <li> <span style={{fontWeight: 'bold'}}>1.</span> Producción de plantas para cultivos industriales (OLIVOS - VID - PLANTAS AROMÁTICAS).</li>
                  <li> <span style={{fontWeight: 'bold'}}>2.</span> Producción de plantas forestales y para forestaciones urbanas.</li>
                  <li> <span style={{fontWeight: 'bold'}}>3.</span> Producción de plantas nativas.</li>
                </ol>
              </div>
              <Typography style={{ width: "50%" }}>
                <div /* style={{ display: "grid" }} */ className={'grid grid-cols-2 gap-1'}>
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                      objectFit: 'contain'
                    }}
                    src={'./ViveroLosAromos/ImagenHojiblanca.jpg'}
                  />
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                    }}
                    src={'./ViveroLosAromos/imagenJardinVarietal.jpg'}
                  />
  
                </div>
              </Typography>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography style={{color: "#f4541c", fontWeight: 'bold'}} className={classes.heading}>
              {" "}
              <CheckIcon />
              División Comercialización
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: "flex" }}>
              <Typography style={{ width: "50%"}}>
              Contamos con un Servicio de Ventas, capacitado para brindar la información necesaria a los clientes, con atención personalizada.
              </Typography>
              <Typography style={{ width: "50%" }}>
                <div /* style={{ display: "grid" }} */ className={'grid grid-cols-2 gap-1'}>
                  <img
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      height: "15rem",
                    }}
                    src={'/ViveroLosAromos/Los Aromos_2025_0037.jpg'}
                  />
                  <img
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      height: "15rem",
                    }}
                    src={'/ViveroLosAromos/Los Aromos_2025_0038.jpg'}
                  />

                </div>  
                
              </Typography>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading} style={{ color: "#f4541c", fontWeight: 'bold' }}>
              <CheckIcon /> Divicion Logística
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: "flex" }}>
              <Typography style={{ width: "50%" }}>
              Nuestra empresa brinda a los clientes la atención de un servicio fundamental, como es el traslado de las plantas al lugar especificado, teniendo todos los recaudos y acondicionamiento necesarios para que las plantas lleguen a destino en perfectas condiciones.
              </Typography>
              <Typography style={{ width: "50%" }}>
                <div /* style={{ display: "grid" }} */ className={'grid grid-cols-2 gap-1'}>
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                      objectFit: 'cover'
                    }}
                    src={'./ViveroLosAromos/Los Aromos_2025_0011.jpg'}
                  />
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                      objectFit: 'cover'
                    }}
                    src={'./ViveroLosAromos/Los Aromos_2025_0018.jpg'}
                  />

                </div>
              </Typography>
            </div>
          </AccordionDetails>
        </Accordion>

       {/*  <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              {" "}
              <CheckIcon />
              Consultoría para Due Diligence - Fusiones y Adquisiciones.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Servicios y Asesoramientos Técnicos GeoMineros.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              {" "}
              <CheckIcon />
              Gestión de Residuos.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Servicios y Asesoramientos Técnicos GeoMineros.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              <CheckIcon />
              Aire / Acústica / Ruido.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Servicios y Asesoramientos Técnicos GeoMineros.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              <CheckIcon />
              Análisis de Riesgo Ecológico y para la Salud.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Servicios y Asesoramientos Técnicos GeoMineros.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              {" "}
              <CheckIcon />
              Ciencias Biológicas.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Servicios y Asesoramientos Técnicos GeoMineros.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              {" "}
              <CheckIcon />
              Análisis de Peligrosidad Sísmica e Ingeniería Sísmica.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Servicios y Asesoramientos Técnicos GeoMineros.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading}>
              <CheckIcon />
              Tunelería.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Servicios y Asesoramientos Técnicos GeoMineros.
            </Typography>
          </AccordionDetails>
        </Accordion> */}
      </div>
      {/* <div class="animate__animated animate__pulse nimate__delay-5s">
        <h1>
        Ofrecemos una amplia gama de servicios de asesoría. Kgori Punku Consultora SRL dispone
        de especialistas en los ámbitos físico, ecológico y económico que
        trabajan en:
        </h1>
        <br></br>
        <ul style={{textAlign: 'initial'}}>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Servicios y Asesoramientos Técnicos GeoMineros.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Aguas Subterráneas / Hidrogeología Minera (Litio/Potasio.)
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Aguas Superficiales. Geoquímica. Geomecánica de Rocas y de Suelos.
            Ingeniería de materiales de construcción y sus respectivos ensayos.
            Geofísica.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Estudios de Medio Ambiente. Evaluación de Impacto Social y
            Ambiental.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Salud y Seguridad - Higiene Industrial. Servicios de Evaluación de
            Reservas y Recursos Minerales.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Asesoría Legal. Servicios de Contratación y Construcción.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Energías Renovables.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Planificación / Diseño / Arquitectura Paisajística.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Urbanización y Reutilización de la Propiedad.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Remediación del Área de Proyecto.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Tratamiento de Aguas Residuales - Ingeniería de Procesos.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Consultoría para Due Diligence - Fusiones y Adquisiciones.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Gestión de Residuos.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Aire / Acústica / Ruido.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Análisis de Riesgo Ecológico y para la Salud.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Ciencias Biológicas.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Análisis de Peligrosidad Sísmica e Ingeniería Sísmica.
          </li>
          <li style={{width: '50%', margin: 'auto'}}>
            <CheckIcon />
            Tunelería.
          </li>
        </ul>
      </div> */}
    </>
  );
};

export const ServicesResponsibo = () => {
  const classes = useStyles();
  return (
    <>
{/*     <h1>
        Ofrecemos una amplia gama de servicios de asesoría. Kgori Punku
        Consultora SRL dispone de especialistas en los ámbitos físico, ecológico
        y económico que trabajan en:
      </h1> */}
      <div
        /* className={classes.root} */ style={{
          marginTop: "30px",
          marginBottom: "20px",
        }}
      >
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography
              className={classes.heading}
              style={{ color: "#f4541c", fontWeight: 'bold' }}
            >
              {" "}
              <CheckIcon />
              División Producción
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <Typography style={{textAlign: 'left'}}>
                Este sector es el encargado de la producción propiamente dicha, de todas las plantas que comercializamos y trabaja con el objetivo de mantener y mejorar en forma continua el rendimiento y la calidad de las mismas, teniendo en cuenta las variaciones de la demanda del mercado en general y de nuestros clientes en particular.

                <br></br>
                <span style={{ fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>NUESTRAS LÍNEAS DE PRODUCCIÓN SON:</span>
                <br></br>

                <ol style={{ textAlign: 'initial', marginTop: '10px', marginBottom: '10px', paddingLeft: '20px' }}>
                  <li> <span style={{ fontWeight: 'bold' }}>1.</span> Producción de plantas para cultivos industriales (OLIVOS - VID - PLANTAS AROMÁTICAS).</li>
                  <li> <span style={{ fontWeight: 'bold' }}>2.</span> Producción de plantas forestales y para forestaciones urbanas.</li>
                  <li> <span style={{ fontWeight: 'bold' }}>3.</span> Producción de plantas nativas.</li>
                </ol>
              </Typography>
              <Typography>
                <div /* style={{ display: "grid" }} */ style={{marginBottom: '20px'}}>
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                      marginTop: '20px'
                    }}
                      src={'./ViveroLosAromos/ImagenHojiblanca.jpg'}
                  />
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                      marginTop: '20px'
                    }}
                   src={'./ViveroLosAromos/imagenJardinVarietal.jpg'}
                  />
                </div>
              </Typography>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography style={{color: "#f4541c", fontWeight: 'bold'}} className={classes.heading}>
              {" "}
              <CheckIcon />
              División Comercialización
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{textAlign: 'left'}}>
              <Typography>
              Contamos con un Servicio de Ventas, capacitado para brindar la información necesaria a los clientes, con atención personalizada.
              </Typography>
              <Typography>
              <img
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      height: "15rem",
                    }}
                    src={'/ViveroLosAromos/Los Aromos_2025_0037.jpg'}
                  />
                  <img
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      height: "15rem",
                    }}
                    src={'/ViveroLosAromos/Los Aromos_2025_0038.jpg'}
                  />

                
              </Typography>
            </div>
          </AccordionDetails>
        </Accordion>

   
      
      </div>


 
      {/*  <div class="animate__animated animate__pulse nimate__delay-5s">
        <h1>
        Ofrecemos una amplia gama de servicios de asesoría. Kgori Punku Consultora SRL dispone
        de especialistas en los ámbitos físico, ecológico y económico que
        trabajan en:
        </h1>
        <br></br>
        <ul style={{textAlign: 'initial'}}>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Servicios y Asesoramientos Técnicos GeoMineros.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Aguas Subterráneas / Hidrogeología Minera (Litio/Potasio.)
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Aguas Superficiales. Geoquímica. Geomecánica de Rocas y de Suelos.
            Ingeniería de materiales de construcción y sus respectivos ensayos.
            Geofísica.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Estudios de Medio Ambiente. Evaluación de Impacto Social y
            Ambiental.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Salud y Seguridad - Higiene Industrial. Servicios de Evaluación de
            Reservas y Recursos Minerales.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Asesoría Legal. Servicios de Contratación y Construcción.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Energías Renovables.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Planificación / Diseño / Arquitectura Paisajística.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Urbanización y Reutilización de la Propiedad.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Remediación del Área de Proyecto.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Tratamiento de Aguas Residuales - Ingeniería de Procesos.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Consultoría para Due Diligence - Fusiones y Adquisiciones.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Gestión de Residuos.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Aire / Acústica / Ruido.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Análisis de Riesgo Ecológico y para la Salud.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Ciencias Biológicas.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Análisis de Peligrosidad Sísmica e Ingeniería Sísmica.
          </li>
          <li style={{width: '100%', marginBottom: '10px'}}>
            <CheckIcon />
            Tunelería.
          </li>
        </ul>
      </div> */}
    </>
  );
};

export const TextProyect = () => {
  return (
    <>
      <div class="animate__animated animate__pulse nimate__delay-5s mb-3 text-center">
        Kgori <span>Punku</span> consultora <span>SRL</span> posee profesionales
        que trabajan bajo la política de "Cero Accidentes", haciendo cumplir la
        normativa vigente de acuerdo al lugar de emplazamiento de cada proyecto.
        Desde el monitoreo constante de las tareas, charlas diarias y
        capacitaciones; junto a la preparación y respuesta ante emergencias como
        pilares fundamentales en la prevencion y minimización de perdidas.
        Nuestros Responsables y Técnicos conocen el Sistema de Gestión EHS (bajo
        Normas ISO 14001 y OSHSAS 18001) y lo aplican en cada uno de nuestros
        Proyectos.
      </div>
    </>
  );
};

export const TextConfianzaResponsibo = () => {
  const classes = useStyles();
  return (
    <>
       <div
        /* className={classes.root} */ style={{
          marginTop: "5px",
          marginBottom: "20px",
          display: "block",
          textAlign: "left",
        }}
      >
              <h1 style={{ marginTop: '10px', marginBottom: '30px' }}>Trabajamos de manera comprometida para preservar la sostenibilidad del planeta mediante diversas acciones:</h1>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading} style={{ color: "#f4541c", fontWeight: 'bold' }}>
            
            
              <CheckIcon />  Cuidado del agua
            </Typography>
          </AccordionSummary>
          <p>Una dimensión fundamental es el cuidado del agua. Hacemos un uso eficiente de este recurso, comprometiéndonos a extender prácticas productivas respetuosas del entorno.</p>
          <AccordionDetails>
            
          <Typography >
                <div /* style={{ display: "grid" }} */ >
                  <img
                    style={{
                      width: "100%",
                      height: "19rem",
                      objectFit: 'cover',
                      marginTop: '20px',
                    }}
                      src={'./ViveroLosAromos/cuidadoAgua.jpg'}
                  />
                <video
                loop
                controls
                muted
                style={{
                  width: "50rem",
                  margin: "auto",
                  height: "30rem",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
              >
                <source src="/videoVivero.mp4" type="video/mp4" />
              </video>


                </div>
              </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography className={classes.heading} style={{ color: "#f4541c", fontWeight: 'bold' }}>
              <CheckIcon /> Generación de energías alternativas
            </Typography>
            
          </AccordionSummary>
          <p>Entendemos que es muy importante realizar cualquier esfuerzo para mitigar el cambio climático. Para ello, en la búsqueda de energías renovables, hemos invertido en la generación de energía a través de la instalación de un sistema solar fotovoltaico interactivo, para generar la totalidad de la energía que necesitamos para llevar a cabo nuestro proceso productivo, y el excedente generado se vuelca a la red de distribución de la empresa estatal. </p>
          <AccordionDetails>
          <Typography>
                <div /* style={{ display: "grid" }} */ >
                  <img
                    style={{
                      width: "100%",
                      marginTop: '20px',
                      objectFit: 'cover',
                      height: "23rem",
                      objectFit: 'contain'
                    }}
                 src={'./imagenPanelSolar.jpg'}
                  />
                  <img
                    style={{
                      width: "100%",
                      marginTop: '20px',
                      objectFit: 'cover',
                      height: "23rem",
                    }}
                    src={'./ViveroLosAromos/Los Aromos_2025_0074.jpg'}
                  />
                </div>
              </Typography>
          </AccordionDetails>
        </Accordion>
 
      </div>
    </>
  );
};

export const TextConfianza = () => {
  const classes = useStyles();
  return (
    <>
      <div
        /* className={classes.root} */ style={{
          marginTop: "5px",
          marginBottom: "20px",
          display: "block",
          textAlign: "left",
        }}
      >
           <h1 style={{ marginTop: '10px', marginBottom: '30px' }}>Trabajamos de manera comprometida para preservar la sostenibilidad del planeta mediante diversas acciones:</h1>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography
              className={classes.heading}
              style={{ color: "#f4541c ", fontWeight: 'bold' }}
            >
              {" "}
              <CheckIcon />
              Cuidado del agua
            </Typography>

          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>
                  <p>Una dimensión fundamental es el cuidado del agua. Hacemos un uso eficiente de este recurso, comprometiéndonos a extender prácticas productivas respetuosas del entorno.</p>
              </div>
              <Typography style={{ width: "50%" }}>
                <div /* style={{ display: "grid" }} */ className={'grid grid-cols-2 gap-1'}>
        

                  <img
                    style={{
                      width: "100%",
                      height: "30rem",
                      objectFit: 'cover'
                    }}
                    src={'./ViveroLosAromos/cuidadoAgua.jpg'}
                  />
                          <video
                loop
                controls
                muted
                style={{
                  width: "50rem",
                  margin: "auto",
                  height: "30rem",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
              >
                <source src="/videoVivero.mp4" type="video/mp4" />
              </video>
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                    }}
                    src={'./ViveroLosAromos/Los Aromos_2025_0074.jpg'}
                  />
                </div>
              </Typography>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography
              className={classes.heading}
              style={{ color: "#f4541c", fontWeight: 'bold' }}
            >
              {" "}
              <CheckIcon />
              Generación de energías alternativas
            </Typography>

          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>
                  <p>Entendemos que es muy importante realizar cualquier esfuerzo para mitigar el cambio climático. Para ello, en la búsqueda de energías renovables, hemos invertido en la generación de energía a través de la instalación de un sistema solar fotovoltaico interactivo, para generar la totalidad de la energía que necesitamos para llevar a cabo nuestro proceso productivo, y el excedente generado se vuelca a la red de distribución de la empresa estatal. </p>
              </div>
              <Typography style={{ width: "50%" }}>
                <div /* style={{ display: "grid" }} */ className={'grid grid-cols-2 gap-1'}>
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                    }}
                    src={'./imagenPanelSolar.jpg'}
                  />
                  <img
                    style={{
                      width: "100%",
                      height: "15rem",
                    }}
                    src={'./ViveroLosAromos/Los Aromos_2025_0074.jpg'}
                  />
                </div>
              </Typography>
            </div>
          </AccordionDetails>
        </Accordion>
       
      </div>
    </>
  );
  /* return (
    <>
      <div class="animate__animated animate__pulse nimate__delay-5s mb-3 " style={{paddingTop: '10px'}}>
     <ul style={{paddingRight: "10%", paddingLeft: "10%", textAlign: 'initial'}}>   
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudio de Suelos para Futuro Proyecto de Obra Civil, Fundaciones: Proyecto para Playa de Lixiviación N° 4 y Proyecto para Instalación de Filtro Prensa - Yacimientos Mineros de Agua de Dionisio - Dpto. Belén/Distrito Hualfín - Provincia de Catamarca. Cliente: YMAD.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Informe Geotécnico: Estudio de Suelos - Proyecto Sal de Vida - Etapa 1 - Zona de Piletas de Evaporación (Halita y Muriato) y Planta de Proceso – Área 4 - Salar del Hombre Muerto-Antofagasta de la sierra, Catamarca, Argentina. Cliente: Worley Argentina S.A.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudios de Suelos, Proyecto de Readecuación de la Geometría de los Depósitos Existentes – C.Q. Planificación del Recrecimiento del Depósito de Barro 02, Campo Quijano, Provincia de Salta. Cliente: Borax Argentina.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Muestreo de isotopía, Salar del Hombre Muerto, Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Livent.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon /></li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudio de Relevamiento Geotécnico para la Construcción de Piletas de Evaporación en el Salar del Hombre Muerto, Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Minera Santa Rita.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudio de Exploración Hidrogeológica en Salmueras de Litio en el Salar del Hombre Muerto, Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Minera Santa Rita.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Caracterización de variables para un mejor conocimiento del balance hídrico del Sistema Hídrico Subterránea - Salar de Olaroz, Provincia de Jujuy. Cliente: Sales de Jujuy.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudio de Mecánica de Suelos – Nueva zona de Piletas de Evaporación-Salar de Olaroz, Dpto. Susques, Provincia de Jujuy. Cliente: Sales de Jujuy.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon /></li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudio de Suelos para fundación – Proyecto Planta de Cal Móvil. Salar de Olaroz, Dpto. Susques, Provincia de Jujuy. Cliente: Sales de Jujuy.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Caracterización de los Suelos de Nuevas Piletas en Construcción: 12A, 12C, 14A, 1AD, 20B, 20C, 20D, 20E, 23A y 23B. Salar de Olaroz, Dpto. Susques, Provincia de Jujuy. Cliente: Sales de Jujuy.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Ensayos de Densidad sobre Muestras Extraídas de Cuttings de Perforación, Salar del hombre Muerto, Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Galaxy Lithium (Sal de Vida) S.A.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Ensayos Químicos en Suelos: Contenido de Materia Orgánica y Agresividad - Proyecto Sal de Vida Etapa 1, Área 4 – Piletas de Evaporación y Planta de Proceso. Salar del hombre Muerto, Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Galaxy Lithium (Sal de Vida) S.A.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Servicio de Geólogos y Técnicos en Higiene y Seguridad Laboral para Campaña de Perforación. Salar del hombre Muerto, Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Galaxy Lithium (Sal de Vida) S.A.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Prospección Geoeléctrica - Línea de Media Tensión y Planta Fotovoltaica. Salar del hombre Muerto, Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Galaxy Lithium (Sal de Vida) S.A.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Supervisión de Sondajes Rotary, Aire Reverso, Diamantina, Diseño de Pozos y Ensayos de Bombeos y Muestreo de Salmueras. Cliente: South American Salars – Advantage Lithium.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudio de No inundabilidad para Proyectos de Construcción. Cliente: Sullair Argentina.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Auditoría Externa para YMAD en Complejo Minero Farallón Negro. Cliente: DIPGAM – Ministerio de Minería, Catamarca.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudio de No inundabilidad para Proyectos de Construcción. Cliente: 360 Energy.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Supervisión de Sondajes con Diamantina, y Muestreo de Salmueras. Salar del Hombre Muerto Antofagasta de la Sierra. Cliente: Albemarle Argentina SRL.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Servicios Geológicos y de Seguridad en Campaña de Exploración con Diamantina, Salar de Incahuasi,  Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Argentina Litio y Energía S.A. (ALE).</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudio de Fundación, Proyecto: Ampliación de Planta, Dpto. El Alto, Provincia de Catamarca. Cliente: Loma Negra – Intercement.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Gerenciamiento de Proyectos Ejecutivos: Puente Sobre Río Cura Quebrada y Puente Sobre Río El Bolsón, Dpto. Antofagasta de la Sierra, Provincia de Catamarca. Cliente: Fideicomiso Minero, Salar del Hombre Muerto.</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Proyecto Ejecutivo: Puente Sobre Río Santa Marpia, Dpto. Santa María, Provincia de Catamarca. Cliente: Consejo Federal de Inversiones (CFI).</li>
      <br></br>
      <li style={{width: '70%', margin: 'auto'}}><CheckIcon />Estudios de Suelos, Proyecto de Readecuación de la Geometría de los Depósitos Existentes – C.Q. Planificación del Recrecimiento del Depósito de Barro 02, Campo Quijano, Provincia de Salta. Cliente: Borax Argentina.</li>
      <br></br>
      <li  style={{width: '70%', margin: 'auto'}}><CheckIcon />Dirección Técnica en Proyecto Antofalla Norte, Salar de Antofalla, Pcia. de Catamarca. Cliente: LEA – TRILA.</li>
      <br></br>
      <li  style={{width: '70%', margin: 'auto'}}><CheckIcon />Elaboración de Cartografía de Departamento El Alto, Pcia. de Catamarca. Cliente: CFI.</li>
      </ul>
      </div>
    </>
  ); */
};
